import { UTMParams } from '@/types';

export function convertUTMParamsToQueryString(utmParams: UTMParams): string {
  const queryParams = Object.entries(utmParams)
    .filter(
      ([_, value]) => value !== undefined && value !== null && value !== '',
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&');

  return queryParams ? `?${queryParams}` : '';
}

export function urlHasUTMParams(params: URLSearchParams) {
  const utmRegex = /^utm_/i; // case-insensitive check
  const paramKeys = Array.from(params.keys());

  return paramKeys.some((key) => {
    const test = utmRegex.test(key);

    return test;
  });
}
